/* begin general import */

import { Row, Spin } from "antd";
import Table, { ColumnProps } from "antd/lib/table";
import {
  AdvanceEnumFilterMaster,
  AdvanceTreeFilterMaster,
  InputSearch,
  LayoutCell,
  Modal,
  OneLineText,
  Pagination,
  TagFilter,
} from "react3l-ui-library";

import { Close20 } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";
import React, { Key } from "react";
import { ResponsibilityAppUserGroupingMappings } from "models/ResponsibilityAppUserGroupingMappings";
import _cloneDeep from "lodash/cloneDeep";
import { RowSelectionType } from "antd/lib/table/interface";
import { Responsibility, ResponsibilityFilter } from "models/Responsibility";
import {
  FilterActionEnum,
  filterService,
} from "services/page-services/filter-service";
import { GuidFilter, IdFilter } from "react3l-advanced-filters";
import { Organization, OrganizationFilter } from "models/Organization";
import { responsibilityRepository } from "repositories/responsibility-repository";
import { memoize } from "lodash";
import { Model } from "react3l-common";
import { AppUserGrouping } from "models/AppUserGrouping";

interface ResponsibilityRoleModalProps {
  // siteId: number;
  // listResponsibilityRole?: ResponsibilityRoleMapping[];
  visibleGroupUser?: boolean;
  setVisibleGroupUser?: any;
  handleCloseModelGroupUser?: () => void;
  list?: ResponsibilityAppUserGroupingMappings[];
  count?: number;
  loadingList?: boolean;
  filter?: any;
  handlePagination?: any;
  handleTableChange?: any;
  model?: Responsibility;
  dispatch?: any;
  modelFilter?: any;
  dispatchFilter?: any;
  handleLoadList?: (e: any) => void;
  // handleCloseResponsibilityRoleModal?: () => void;
  // handleSaveResponsibilityRoleModal?: (selectedList: Role[]) => void;
}

export function ResponsibilityGroupUserModal(
  props: ResponsibilityRoleModalProps
) {
  const {
    visibleGroupUser,
    setVisibleGroupUser,
    handleCloseModelGroupUser,
    list,
    count,
    loadingList,
    filter,
    handlePagination,
    handleTableChange,
    model,
    dispatch,
    modelFilter,
    dispatchFilter,
  } = props;

  const {
    handleChangeSingleTreeFilter,
    handleChangeAllFilter,
    handleChangeInputSearch,
  } = filterService.useFilter(modelFilter, dispatchFilter);

  const typeRowSelection: RowSelectionType = "checkbox";
  const [translate] = useTranslation();
  const [selectedRowKeys, setSelectedRowKeys] = React.useState<Key[]>([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [isFirstLoad, setIsFirstLoad] = React.useState(false);

  const pushArrSelected = React.useCallback(
    (item: any) => {
      const selectedRowKeysHere = _cloneDeep(selectedRowKeys);
      const selectedRowsHere = _cloneDeep(selectedRows);
      selectedRowKeysHere.push(item?.id);
      selectedRowsHere.push(item);
      setSelectedRowKeys(selectedRowKeysHere);
      setSelectedRows(selectedRowsHere);
    },
    [selectedRowKeys, selectedRows]
  );

  const deleteArrNotSelect = React.useCallback(
    (item: ResponsibilityAppUserGroupingMappings) => {
      const selectedRowKeysHere = _cloneDeep(selectedRowKeys);
      const selectedRowsHere = _cloneDeep(selectedRows);
      selectedRowKeysHere.splice(selectedRowKeysHere?.indexOf(item?.id), 1);
      const index = selectedRowsHere?.findIndex((obj: any) => {
        return obj?.id === item?.id;
      });
      selectedRowsHere.splice(index, 1);
      setSelectedRowKeys(selectedRowKeysHere);
      setSelectedRows(selectedRowsHere);
    },
    [selectedRowKeys, selectedRows]
  );

  const handleCheckAll = React.useCallback(
    (selected: boolean, rows: any[], changeRows: any[]) => {
      const selectedIds = changeRows.map((row: any) => row.id);
      const selectedRowKeysHere = _cloneDeep(selectedRowKeys);
      const selectedRowsHere = _cloneDeep(selectedRows);
      if (selected) {
        const selectedRowKeysHereSet = selectedRowKeysHere.concat(selectedIds);
        const selectedRowsHereSet = selectedRowsHere.concat(changeRows);
        setSelectedRowKeys(selectedRowKeysHereSet);
        setSelectedRows(selectedRowsHereSet);
      } else {
        for (let z = 0; z < changeRows.length; z++) {
          selectedRowKeysHere.splice(
            selectedRowKeysHere?.indexOf(changeRows[z]?.id),
            1
          );
          const index = selectedRowsHere?.findIndex((obj: any) => {
            return obj?.id === changeRows[z]?.id;
          });
          selectedRowsHere.splice(index, 1);
        }
        setSelectedRowKeys(selectedRowKeysHere);
        setSelectedRows(selectedRowsHere);
      }
    },
    [selectedRowKeys, selectedRows]
  );

  const rowSelection = {
    onSelect(record: any, selected: boolean) {
      if (selected === true) {
        pushArrSelected(record);
      } else {
        deleteArrNotSelect(record);
      }
    },
    onSelectAll(selected: boolean, selectedRows: any, changeRows: any) {
      handleCheckAll(selected, selectedRows, changeRows);
    },
    selectedRowKeys,
    type: typeRowSelection,
    list: selectedRows,
  };

  const handleSaveModalGroupUsers = React.useCallback(() => {
    const modelHere = _cloneDeep(model);
    const modelSave = selectedRows.map((x: any) => {
      return {
        appUserGrouping: x,
        appUserGroupingId: x?.id,
        disabled: null,
        errors: null,
        generalErrors: [],
        generalInformations: [],
        generalWarnings: [],
        informations: null,
        responsibilityId: model?.id,
        warnings: null,
      };
    });
    modelHere.responsibilityAppUserGroupingMappings = modelSave;
    dispatch({
      type: FilterActionEnum.UPDATE,
      payload: modelHere,
    });
    setVisibleGroupUser(false);
    setIsFirstLoad(false);
  }, [dispatch, model, selectedRows, setVisibleGroupUser]);

  const handleChangeSelectFilter = React.useMemo(
    () =>
      memoize(
        (config: {
            fieldName: string;
            fieldType: string;
            classFilter: new (partial?: any) => IdFilter | GuidFilter;
          }) =>
          (idValue: number, value: Model) => {
            const { fieldName, fieldType, classFilter: ClassFilter } = config;
            const newFilter =
              idValue === 1
                ? {
                    ...modelFilter,
                    [`${fieldName}Value`]: value,
                    [`${fieldName}Id`]: Object.assign(new ClassFilter(), {
                      [fieldType]: idValue,
                    }),
                    id: {
                      in: selectedRowKeys,
                    },
                    skip: 0,
                  }
                : idValue === 2
                ? {
                    ...modelFilter,
                    [`${fieldName}Value`]: value,
                    [`${fieldName}Id`]: Object.assign(new ClassFilter(), {
                      [fieldType]: idValue,
                    }),
                    id: {
                      notIn: selectedRowKeys,
                    },
                    skip: 0,
                  }
                : {
                    ...modelFilter,
                    [`${fieldName}Value`]: value,
                    [`${fieldName}Id`]: Object.assign(new ClassFilter(), {
                      [fieldType]: idValue,
                    }),
                    id: new IdFilter(),
                    skip: 0,
                  };
            handleChangeAllFilter(newFilter);
          }
      ),
    [modelFilter, selectedRowKeys, handleChangeAllFilter]
  );

  const columns: ColumnProps<ResponsibilityAppUserGroupingMappings>[] =
    React.useMemo(() => {
      return [
        {
          title: (
            <div className="text-left gradient-text">
              {translate("responsibilities.listUserGroup.code")}
            </div>
          ),
          key: "code",
          dataIndex: "code",
          width: 150,
          ellipsis: true,
          render(
            ...params: [string, ResponsibilityAppUserGroupingMappings, number]
          ) {
            return (
              <LayoutCell orderType="left" tableSize="md">
                <OneLineText countCharacters={50} value={params[0]} />
              </LayoutCell>
            );
          },
        },
        {
          title: (
            <div className="text-left gradient-text">
              {translate("responsibilities.listUserGroup.name")}
            </div>
          ),
          width: 150,
          key: "name",
          dataIndex: "name",
          ellipsis: true,
          render(
            ...params: [string, ResponsibilityAppUserGroupingMappings, number]
          ) {
            return (
              <LayoutCell orderType="left" tableSize="md">
                <OneLineText countCharacters={50} value={params[0]} />
              </LayoutCell>
            );
          },
        },
        {
          title: (
            <div className="text-left gradient-text">
              {translate("responsibilities.listUserGroup.managementUnit")}
            </div>
          ),
          width: 150,

          key: "organization",
          dataIndex: "appUserGroupingOrganizationMappings",
          ellipsis: true,
          render(
            ...params: [
              AppUserGrouping[],
              ResponsibilityAppUserGroupingMappings,
              number
            ]
          ) {
            const listOrganizationNames = params[0].map(
              (item: Organization) => item?.organization?.name
            );
            return (
              <LayoutCell orderType="left" tableSize="md">
                <OneLineText
                  countCharacters={50}
                  value={listOrganizationNames.join(", ")}
                />
              </LayoutCell>
            );
          },
        },
      ];
    }, [translate]);

  const handleChangeTagFilter = React.useCallback(
    (data: any) => {
      if (!data.selectStatusId?.equal) {
        data.id = {};
        handleChangeAllFilter(data);
      } else {
        handleChangeAllFilter(data);
      }
    },
    [handleChangeAllFilter]
  );

  React.useEffect(() => {
    if (
      model?.responsibilityAppUserGroupingMappings?.length > 0 &&
      isFirstLoad === false
    ) {
      setIsFirstLoad(true);
      const selectedRowKeysHere = _cloneDeep(selectedRowKeys);
      const selectedRowsHere = _cloneDeep(selectedRows);
      for (
        let i = 0;
        i < model?.responsibilityAppUserGroupingMappings?.length;
        i++
      ) {
        selectedRowKeysHere.push(
          model?.responsibilityAppUserGroupingMappings[i]?.appUserGrouping?.id
        );
        selectedRowsHere.push(
          model?.responsibilityAppUserGroupingMappings[i]?.appUserGrouping
        );
        setSelectedRowKeys(selectedRowKeysHere);
        setSelectedRows(selectedRowsHere);
      }
    }
  }, [
    model?.responsibilityAppUserGroupingMappings,
    pushArrSelected,
    isFirstLoad,
    selectedRows,
    selectedRowKeys,
  ]);

  return (
    <Modal
      size={1024}
      visible={visibleGroupUser}
      visibleFooter={true}
      handleCancel={handleCloseModelGroupUser}
      handleSave={handleSaveModalGroupUsers}
      titleButtonCancel={translate("general.actions.close")}
      titleButtonApply={translate("general.actions.save")}
      className="m-t--sm"
      title={translate("responsibilities.listUserGroup.title")}
      closable={false}
      wrapClassName={"dxg-modal-wrap"}
    >
      <Spin spinning={loadingList}>
        <div className="page-master__tag-filter">
          <TagFilter
            value={modelFilter}
            translate={translate}
            keyTranslate={"responsibilities.filter"}
            handleChangeFilter={handleChangeTagFilter}
            onClear={(value: any) => {
              return 0;
            }}
          />
        </div>
        <div className="d-flex align-items-center">
          <div>
            <AdvanceTreeFilterMaster
              onChange={handleChangeSingleTreeFilter({
                fieldName: "organization",
                fieldType: "equal",
                classFilter: IdFilter,
              })}
              maxLengthItem={20}
              classFilter={OrganizationFilter}
              placeHolder={translate(
                "responsibilities.listUserGroup.filter.organization"
              )}
              label={translate(
                "responsibilities.listUserGroup.filter.organization"
              )}
              getTreeData={responsibilityRepository?.filterListOrganization}
              searchProperty="search"
              searchType=""
              item={modelFilter["organizationValue"]}
              render={(organization: Organization) => {
                return organization?.code
                  ? `${organization?.code} - ${organization?.name}`
                  : null;
              }}
            />
          </div>
          <div>
            <AdvanceEnumFilterMaster
              value={modelFilter?.selectStatusId?.equal}
              onChange={handleChangeSelectFilter({
                fieldName: "selectStatus",
                fieldType: "equal",
                classFilter: IdFilter,
              })}
              getList={responsibilityRepository.filterListSelectStatus}
              label={translate("responsibilities.listUserGroup.filter.status")}
              appendToBody
            />
          </div>
          <div className="w-near70">
            <InputSearch
              value={filter.search}
              classFilter={ResponsibilityFilter}
              placeHolder={translate("general.placeholder.search")}
              onChange={handleChangeInputSearch}
              animationInput={filter?.search ? false : true}
            />
          </div>
        </div>

        <div className="modal-content">
          <Row>
            <Table
              tableLayout="fixed"
              columns={columns}
              dataSource={list}
              pagination={false}
              rowKey={"id"}
              className=" m-t--xs"
              scroll={{ y: 300 }}
              onChange={handleTableChange}
              rowSelection={rowSelection}
            />
            <Pagination
              skip={filter?.skip}
              take={filter?.take}
              total={count}
              onChange={handlePagination}
            />
          </Row>
        </div>
        <span className={"close-modal"} onClick={handleCloseModelGroupUser}>
          <Close20 />
        </span>
      </Spin>
    </Modal>
  );
}

export default ResponsibilityGroupUserModal;
